// src/config.js
// const API_BASE_URL = 'http://localhost:8081/api';
const API_BASE_URL = 'https://api.ledspeedsigns.com.au/api';
// [NOT IN USE] const API_BASE_URL = 'http://20.42.206.190/api';
  
export default API_BASE_URL;

// FABwbluTIBErXwvbsU/V7TZWfmbgJfbkwiBuziS9gxdODU

// https://github.com/sponsors/sindresorhus
